import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";
import { projectQueryOptions } from "$/modules/projects/lib/queries";
import { AccessTab } from "$/modules/settings/ui/access-tab";
import { DataTab } from "$/modules/settings/ui/data-tab";
import { GeneralTab } from "$/modules/settings/ui/general-tab";
import { ConstructionHeader } from "$/modules/shared/ui/construction-header";
import {
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from "$/modules/shared/ui/tabs";

export const Route = createFileRoute(
	"/$locale/$userId/projects/$projectId/settings/",
)({
	component: SettingsPage,
	loader: async ({ params, context: { queryClient } }) => {
		await queryClient.ensureQueryData({
			...projectQueryOptions(params.userId, params.projectId),
			revalidateIfStale: true,
		});
	},
});

function SettingsPage() {
	const t = useTranslations("settings.tabs");
	const { userId, projectId } = Route.useParams();
	const { data: project } = useSuspenseQuery(
		projectQueryOptions(userId, projectId),
	);

	return (
		<>
			<ConstructionHeader titleKey="project.sidebar.settings" />

			<Tabs defaultValue="general">
				<TabsList className="max-w-full flex-wrap h-auto">
					<TabsTrigger value="general">{t("general")}</TabsTrigger>
					<TabsTrigger value="data">{t("data")}</TabsTrigger>
					<TabsTrigger value="access">{t("access")}</TabsTrigger>
				</TabsList>
				<TabsContent value="general">
					<GeneralTab project={project} />
				</TabsContent>
				<TabsContent value="data">
					<DataTab project={project} />
				</TabsContent>
				<TabsContent value="access">
					<AccessTab project={project} />
				</TabsContent>
			</Tabs>
		</>
	);
}
